document.addEventListener("DOMContentLoaded", () => {
  const productInfo = document.querySelector(".product__info-container");
  if (!productInfo) return;

  const policyCache = {}; // 缓存预加载内容

  // 预加载所有 Product Info 链接内容
  const links = productInfo.querySelectorAll(".product__text a, .product__tax a");
  links.forEach(link => {
    const url = link.href;
    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        // 只取正文部分
        const content = doc.querySelector(".shopify-policy__container") || doc.querySelector("body");
        policyCache[url] = content.innerHTML;
      })
      .catch(err => console.error("预加载失败:", url, err));

    // 阻止默认跳转，添加识别 class
    link.dataset.policy = url;
    link.setAttribute("href", "#");
    link.classList.add("js-open-policy");
  });

  // 弹窗逻辑
  document.body.addEventListener("click", (e) => {
    const target = e.target.closest(".js-open-policy");
    if (!target) return;

    e.preventDefault();
    const url = target.dataset.policy;

    // 删除已有弹窗
    let oldModal = document.querySelector("#customPolicyModal");
    if (oldModal) oldModal.remove();

    // 创建弹窗
    const modal = document.createElement("div");
    modal.id = "customPolicyModal";
    modal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.6);
      z-index: 9999;
      display: flex;
      align-items: center;
      justify-content: center;
    `;

    // 弹窗内容
    const contentHTML = policyCache[url] || "<p>Loading...</p>";
    modal.innerHTML = `
      <div style="
        background:#fff;
        width:90%;
        max-width:600px;
        height:80%;
        border-radius:8px;
        overflow:auto;
        position:relative;
        padding:1rem;
      ">
        <button id="closePolicyModal" style="
          position:absolute;
          top:10px;
          right:10px;
          background:none;
          border:none;
          font-size:20px;
          cursor:pointer;
        ">✖</button>
        <div class="policy-content">${contentHTML}</div>
      </div>
    `;

    document.body.appendChild(modal);

    // 关闭按钮
    modal.querySelector("#closePolicyModal").addEventListener("click", () => modal.remove());

    // 点击黑色背景关闭
    modal.addEventListener("click", (event) => {
      if (event.target === modal) modal.remove();
    });
  });
});
